import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../include/api';
import { useNotification } from '../Toast/ToastProvider';
import { ERROR, SUCCESS } from '../include/constant';

const Contact = () => {
    const toast = useNotification()   
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      mobileNo: "",
      subject: "",
      message: "",
    });

    const [loading, setLoading] = useState(false);

      const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
      };
     
    const handleSubmit = (e) =>   {
      e.preventDefault();
        setLoading(true);
  api.post('/contact_us/',formData).then(response => {
            if (response.status === 200) {
                setFormData({
                  name: "",
                  email: "",
                  mobileNo: "",
                  subject: "",
                  message: "",
                });
                  toast({ type: SUCCESS, message: response.data.message })
            }
  }).catch(error => {
      error.response
        ? toast({ type: ERROR, message: error.response.data.message })
        : toast({ type: ERROR, message: error.message });
  }).finally(() => {

    setLoading(false)
  })
    }

    return (
      <section className="contact py-80" style={{ marginTop: 160 }}>
        <div className="container container-lg">
          <div className="row gy-5">
            <div className="col-lg-8">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <form onSubmit={handleSubmit}>
                  <h6 className="mb-32">Make Custom Request </h6>
                  <div className="row gy-4">
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="name"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Full Name{" "}
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        className="common-input px-16"
                        id="name"
                        placeholder="Full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="email"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Email Address{" "}
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="email"
                        className="common-input px-16"
                        id="email"
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="phone"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Phone Number
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="tel"
                        className="common-input px-16"
                        id="mobileNo"
                        placeholder="Phone Number*"
                        value={formData.mobileNo}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="subject"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Subject
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="text"
                        className="common-input px-16"
                        id="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-sm-12">
                      <label
                        htmlFor="message"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Message
                        <span className="text-danger text-xl line-height-1">
                          *
                        </span>{" "}
                      </label>
                      <textarea
                        className="common-input px-16"
                        id="message"
                        placeholder="Type your message"
                        
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-sm-12 mt-32">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-32 rounded-8"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Get a Quote"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <h6 className="mb-48">Get In Touch</h6>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-phone-call" />
                  </span>
                  <Link
                    to="/tel:+00123456789"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    +91 900-33-786-41
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-envelope" />
                  </span>
                  <Link
                    to="/mailto:info@powergroups.in"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    info@powergroups.in
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-0">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-map-pin" />
                  </span>
                  <span className="text-md text-gray-900 ">
                    No: 6/485A,
                    <br />
                    Time Square,
                    <br />
                    Pudukottai main road,
                    <br />
                    Gundur,
                    <br />
                    Trichy-620007.
                  </span>
                </div>
                <div className="flex-align gap-16 mb-0">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-globe" />
                  </span>
                  <Link
                    to="/https://www.powergroups.in/"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    www.powergroups.in
                  </Link>
                </div>
              </div>
              <div className="mt-24 flex-align flex-wrap gap-16">
                <Link
                  to="tel:+919003378641"
                  className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                >
                  <span className="text-white fw-medium">
                    Get Support On Call
                  </span>
                  <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                    <i className="ph ph-headset" />
                  </span>
                </Link>
                <a
                  href="https://www.google.com/maps?q=10.7266226,78.7152987"
                  target="_blank"
                  className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1 mt-3 d-inline-flex align-items-center"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="text-white fw-medium">Get Direction</span>
                  <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white ms-2">
                    <i className="ph ph-map-pin" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default Contact